import { isPriceTestingEnabledCookieSet } from "@/react/utils/isCookieSet";
import { useExperimentEnabled } from "./useExperimentEnabled";

const PRICE_TESTING_FLAG_NAME = "professional_price_test";

export const usePriceTestingEnabled = () =>
  useExperimentEnabled(PRICE_TESTING_FLAG_NAME) ||
  isPriceTestingEnabledCookieSet();
